module.exports = __webpack_public_path__ + "static/media/hint_correct_borroso.c23e2d57.png";